<template>
  <div style="display: contents;">
    <tr>
      <td>
        <b-checkbox
          v-model="checkboxModel"
          :disabled="!supplement.is_optional"
          :indeterminate="checkboxIndeterminate"
          @change="onCheckboxChange"
        >
          <small>{{ supplement.name }}</small>
        </b-checkbox>
      </td>
      <td class="text-danger" nowrap>
        <small>
          <template v-if="supplement.is_optional">
            {{ price.toFixed(2) }} {{ currency }}
          </template>
          <template v-else>
            <translate>included</translate>
          </template>
        </small>
      </td>
      <td>
        <small v-if="supplement.application_model == 'per pax' && supplement.is_optional"><b-icon variant="primary" icon="caret-down-fill" @click="togglePax()" /></small>
      </td>
    </tr>
    <template v-if="showPax">
      <template v-for="(room, roomIndex) in pax">
        <template v-for="(p, paxIndex) in room">
          <SupplementPax
            :pax="p"
            :roomIndex="roomIndex"
            :paxIndex="paxIndex"
            :currency="currency"
            :paxPrices="supplement.pax_prices"
            :checked="isChecked(roomIndex, paxIndex)"
            @change="onPaxSelectionChange($event, roomIndex, paxIndex)"
            :key="'pax_' + roomIndex + '_' + paxIndex" />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import SupplementPax from './supplement_pax'

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    supplement: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: {
    SupplementPax
  },
  data () {
    const paxCheckboxes = []
    this.pax.forEach(room => {
      room.forEach(pax => {
        paxCheckboxes.push(this.checked)
      })
    })
    return {
      showPax: false,
      checkboxIndeterminate: false,
      checkboxModel: this.checked,
      paxCheckboxes
    }
  },
  computed: {
    price () {
      return this.supplement.price.gross + this.supplement.price.tax
    }
  },
  methods: {
    togglePax () {
      this.showPax = !this.showPax
    },
    onPaxSelectionChange ($event, roomIndex, paxIndex) {
      if (this.supplement.application_model === 'per pax') {
        this.supplement.pax[roomIndex][paxIndex] = $event
        const someChecked = this.supplement.pax.some(room => room.some(pax => pax))
        const someUnchecked = this.supplement.pax.some(room => room.some(pax => !pax))
        this.$emit('change', someChecked)
        this.checkboxIndeterminate = someChecked && someUnchecked
      }
    },
    onCheckboxChange (value) {
      const paxCheckboxes = []
      if (value) {
        this.supplement.pax.forEach((room, roomIndex) => {
          room.forEach((pax, paxIndex) => {
            this.supplement.pax[roomIndex][paxIndex] = true
            paxCheckboxes.push(true)
          })
        })
      } else {
        this.supplement.pax.forEach((room, roomIndex) => {
          room.forEach((pax, paxIndex) => {
            this.supplement.pax[roomIndex][paxIndex] = false
          })
        })
      }
      this.paxCheckboxes = paxCheckboxes
      this.$emit('change', this.checkboxModel)
    },
    isChecked (roomIndex, paxIndex) {
      let realIndex = 0
      this.pax.forEach((room, index) => {
        if (index < roomIndex) {
          realIndex += room.length
        }
      })
      realIndex += paxIndex
      return this.paxCheckboxes[realIndex]
    }
  },
  watch: {
    checked (value) {
      this.checkboxModel = value
    }
  }
}

</script>
